module.exports = require("@nextcloud/event-bus");